import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../core/i18n'
import { BREAKPOINT_TABLET_SMALL, COLORS } from '../../../static/constants'

interface IProps {
  label: string
  required?: boolean
  wrap?: boolean
  error?: null | string
}

const FormItem: React.FC<IProps> = ({ label, required, wrap = false, error, children }) => {
  return (
    <S.FormItem className={wrap ? 'wrap' : ''}>
      {(label || required) && (
        <S.Title className={wrap ? 'wrap' : ''}>
          {label}
          {required && <S.Required>{I18n.t('generic.required')}</S.Required>}
        </S.Title>
      )}
      <S.Main>
        {children}
        {error && <S.Error>{error}</S.Error>}
      </S.Main>
    </S.FormItem>
  )
}

export const S: { [key: string]: AnyStyledComponent } = {}

S.FormItem = styled.div`
  display: flex;
  &.wrap {
    margin-top: 8px;
    flex-direction: column;
  }
  @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
    margin-top: 16px;
    flex-direction: column;
  }
`

S.Title = styled.p`
  width: 240px;
  margin-top: 8px;

  font-size: 14px;
  font-weight: bold;
  &.wrap {
    width: 100%;
    margin-bottom: 8px;
  }
  @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
    width: 100%;
    margin-bottom: 12px;
  }
`

S.Main = styled.div`
  flex: 1;
`

S.Required = styled.span`
  display: inline-block;
  border-radius: 3px;
  color: ${COLORS.white};
  background-color: ${COLORS.caution};
  vertical-align: middle;
  font-size: 11px;
  font-weight: normal;
  padding: 4px 6px;
  margin-left: 8px;
`

S.Error = styled.span`
  display: block;
  margin-top: 8px;
  color: ${COLORS.cautionText};
  font-size: 14px;
`

export default FormItem
